export default function validateHeaders(header, template) {
  return header.every((h, i) => h.toLowerCase().trim() === template[i].toLowerCase().trim())
}
